import { FC } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import { ColType, SortKey } from 'common/types/summaryDefinitions';
import { ValueType } from 'common/types/summaryDefinitions/valueTypes/valueType';

export interface SortChipsBarProps {
  sortKeys: SortKey[];
  valueTypeById: Map<string, ValueType>;
  onClearAll: () => void;
  onRemoveSort: (columnType: ColType) => void;
}

const buildChipLabel = (sortKey: SortKey, valueTypeById: Map<string, ValueType>): string => {
  const [colType, direction] = sortKey;
  const displayName = valueTypeById.get(colType)?.displayName ?? colType;
  return `${displayName} (${direction})`;
};

const SortChipsBar: FC<SortChipsBarProps> = ({ sortKeys, valueTypeById, onClearAll, onRemoveSort }) => {
  if (sortKeys.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 0.75,
        px: 1,
        pt: 0.75,
        pb: 1,
        borderBottom: '1px solid',
        borderColor: 'divider',
        mb: 0.5,
      }}>
      <Typography
        variant="caption"
        color="primary"
        sx={{ fontWeight: 600, whiteSpace: 'nowrap', mr: 0.25 }}>
        Active sorting:
      </Typography>
      {sortKeys.map(sortKey => {
        const [colType] = sortKey;
        return (
          <Chip
            key={colType}
            label={buildChipLabel(sortKey, valueTypeById)}
            size="small"
            color="primary"
            onDelete={() => onRemoveSort(colType)}
          />
        );
      })}
      <Button
        size="small"
        variant="text"
        color="primary"
        onClick={onClearAll}
        sx={{ ml: 0.25, px: 0.5, py: 0, minWidth: 'auto', textTransform: 'none', fontWeight: 500, fontSize: '0.75rem' }}>
        Clear all
      </Button>
    </Box>
  );
};

export default SortChipsBar;
